import { supabase } from '../../lib/supabase';

/**
 * Insert diretto su `deal_notes` — porting letterale della fonte (:490-506), usato per la
 * nota SENZA cambio di stato: non passa da `addDealNote` e quindi non emette
 * `deal:note_created` (vedi "superficie eventi" nel docstring dell'adapter).
 * A differenza della fonte, l'assenza della riga inserita è un errore, non un silenzio.
 */
export async function insertDealNoteDirect(dealId: string, html: string): Promise<string> {
  const { data: userData } = await supabase.auth.getUser();
  const { data: profile } = await supabase
    .from('user_profiles')
    .select('organization_id')
    .eq('id', userData.user?.id || '')
    .single();
  const { data: insertedNote, error: noteErr } = await supabase
    .from('deal_notes')
    .insert({
      deal_id: dealId,
      user_id: userData.user?.id,
      content: html,
      organization_id: profile?.organization_id,
    })
    .select('id')
    .single();
  if (noteErr) throw noteErr;
  if (!insertedNote?.id) throw new Error('Salvataggio della nota fallito');
  return insertedNote.id;
}

/** Esito dell'upload allegati: `null` = niente da dire (nessun file, o tutto liscio e muto). */
export type AttachmentOutcome = { level: 'success' | 'error'; text: string } | null;

/** Upload sequenziale degli allegati della nota, con messaggio riassuntivo (fonte :508-517). */
export async function uploadNoteFiles(
  noteId: string,
  files: File[],
  upload: (noteId: string, file: File) => Promise<unknown>
): Promise<AttachmentOutcome> {
  if (files.length === 0) return null;
  try {
    let uploaded = 0;
    let failed = 0;
    for (const file of files) {
      if (await upload(noteId, file)) uploaded++;
      else failed++;
    }
    const plural = (n: number, s: string, p: string) => (n > 1 ? p : s);
    if (failed === 0) {
      return { level: 'success', text: `Nota salvata con ${uploaded} ${plural(uploaded, 'allegato', 'allegati')}` };
    }
    if (uploaded > 0) {
      return {
        level: 'error',
        text: `Nota salvata: ${uploaded} ${plural(uploaded, 'allegato caricato', 'allegati caricati')}, ${failed} ${plural(failed, 'fallito', 'falliti')}`,
      };
    }
    return { level: 'error', text: 'Nota salvata ma nessun allegato è stato caricato' };
  } catch (error) {
    console.error('[dealDrawerAdapter] upload allegati fallito:', error);
    return { level: 'error', text: 'Nota salvata ma alcuni allegati non sono stati caricati' };
  }
}
